import { IRouteMap } from '@opengov/compose-app-router/types';

import { maintenanceRoute } from '../maintenance';
import {
  onlinePublicationMenuRoute,
  organizeSectionsAndStoriesRoute,
  organizeStoriesAndFoldersRoute,
  publicationCustomCssRoute,
  publicationListRoute,
  publicationReportEmbedRoute,
  publicationTemplateListRoute,
  publicationViewRoute,
  publicationCustomReportRoute,
  setupOnlinePublicationRoute,
  setupPdfRoute,
  storiesSettingsRoute,
  storyListRoute,
  storyPreviewRoute,
  storySetupPDFRoute,
  storyViewRoute
} from '../stories/routes';
import { templateListRoute } from '../stories/routes/storyListRoute';

import { ensureEntity } from './onEnter';

export const routes: IRouteMap = {
  '/stories(/)': ensureEntity,
  '/stories/settings/:entitySubdomain(/:tab)(/)': storiesSettingsRoute,
  '/stories/:entitySubdomain(/)': publicationListRoute,
  '/stories/:entitySubdomain/stories(/)': storyListRoute,
  '/stories/:entitySubdomain/drafts(/)': storyListRoute,
  '/stories/:entitySubdomain/templates(/)': templateListRoute,
  '/stories/:entitySubdomain/create-from-template(/)': templateListRoute,
  '/stories/:entitySubdomain/folders(/)': storyListRoute,
  '/stories/:entitySubdomain/folders/:folderId': storyListRoute,
  '/stories/:entitySubdomain/story/:storyId(/)': storyViewRoute,
  '/stories/:entitySubdomain/publication/:publicationId/story/:storyId(/)': storyViewRoute,
  '/stories/:entitySubdomain/story/:storyId/preview(/)': storyPreviewRoute,
  '/stories/:entitySubdomain/story/:storyId/edit(/)': storyViewRoute,
  '/stories/:entitySubdomain/template/:storyId(/)': storyViewRoute,
  '/stories/:entitySubdomain/template/:storyId/preview(/)': storyPreviewRoute,
  '/stories/:entitySubdomain/template/:storyId/edit(/)': storyViewRoute,
  '/stories/:entitySubdomain/maintenance(/)': maintenanceRoute,
  '/stories/:entitySubdomain/folders/:folderId/organize/:selectedFolderId': organizeStoriesAndFoldersRoute,
  '/stories/:entitySubdomain/publications(/)': publicationListRoute,
  '/stories/:entitySubdomain/publications/:publicationId/stories(/)': publicationViewRoute,
  '/stories/:entitySubdomain/publications/:publicationId/create-from-template(/)': publicationTemplateListRoute,
  '/stories/:entitySubdomain/publication/:publicationId/story/:storyId/edit(/)': storyViewRoute,
  '/stories/:entitySubdomain/publications/:publicationId/sections/:sectionId(/)': publicationViewRoute,
  '/stories/:entitySubdomain/publications/:publicationId/stories/copy-process/:copyPublicationJobId(/)':
    publicationViewRoute,
  '/stories/:entitySubdomain/publications/:publicationId/sections/:sectionId/organize/:selectedSectionId':
    organizeSectionsAndStoriesRoute,
  '/stories/:entitySubdomain/publications/:publicationId/onlinePublication(/)': setupOnlinePublicationRoute,
  '/stories/:entitySubdomain/publications/:publicationId/onlinePublication/:tabId': setupOnlinePublicationRoute,
  '/stories/:entitySubdomain/publications/:publicationId/onlinePublication/menus/:menuId': onlinePublicationMenuRoute,
  '/stories/:entitySubdomain/publications/:publicationId/custom-css(/:storyId)': publicationCustomCssRoute,
  '/stories/:entitySubdomain/publications/:publicationId/embedded-reports(/)': publicationReportEmbedRoute,
  '/stories/:entitySubdomain/publications/:publicationId/custom-reports(/)': publicationCustomReportRoute,
  '/stories/:entitySubdomain/:exportType/:exportId/setup-pdf(/)': setupPdfRoute,
  '/stories/:entitySubdomain/publications/:publicationId/story/:storyId/setup-pdf(/)': storySetupPDFRoute,
  '/stories/:entitySubdomain/story/:storyId/setup-pdf(/)': storySetupPDFRoute
};
